"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));

var _Score = _interopRequireDefault(require("./Score"));

var _UIUtil = _interopRequireDefault(require("../util/UIUtil"));

var BreakdownScore =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BreakdownScore, _React$Component);

  function BreakdownScore() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BreakdownScore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(BreakdownScore)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.titleClicked = function () {
      _UIUtil.default.scrollTo("#" + _this.props.page);
    };

    return _this;
  }

  (0, _createClass2.default)(BreakdownScore, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          score = _this$props.score,
          overallScore = _this$props.overallScore,
          page = _this$props.page;
      var scorePercentage = score / overallScore * 100;
      return _react.default.createElement(_Score.default, {
        scorePercentage: scorePercentage,
        onClick: this.titleClicked
      }, _react.default.createElement("div", {
        className: "score-title"
      }, _react.default.createElement("div", {
        className: "auditTitle"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "results." + page + ".title"
      })), _react.default.createElement("div", {
        className: "score"
      }, score, _react.default.createElement("span", {
        className: "overall"
      }, "/", overallScore))), _react.default.createElement(_ProgressBar.default, {
        scorePercentage: scorePercentage
      }));
    }
  }]);
  return BreakdownScore;
}(_react.default.Component);

exports.default = BreakdownScore;
BreakdownScore.propTypes = {
  page: _propTypes.default.string.isRequired,
  score: _propTypes.default.number.isRequired,
  overallScore: _propTypes.default.number.isRequired
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/BreakdownScore.js
// module id = 311
// module chunks = 0